import { render } from "./Carrier.vue?vue&type=template&id=d41fc5ac"
import script from "./Carrier.vue?vue&type=script&lang=js"
export * from "./Carrier.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__